import { render } from "./UsageView.vue?vue&type=template&id=48ca68f1&scoped=true"
import script from "./UsageView.vue?vue&type=script&lang=js"
export * from "./UsageView.vue?vue&type=script&lang=js"

import "./UsageView.vue?vue&type=style&index=0&id=48ca68f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ca68f1"]])

export default __exports__